/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyCreateRequest
 */
export interface CompanyCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    heroImage?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    license?: string;
}

/**
 * Check if a given object implements the CompanyCreateRequest interface.
 */
export function instanceOfCompanyCreateRequest(value: object): value is CompanyCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompanyCreateRequestFromJSON(json: any): CompanyCreateRequest {
    return CompanyCreateRequestFromJSONTyped(json, false);
}

export function CompanyCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'heroImage': json['heroImage'] == null ? undefined : json['heroImage'],
        'color': json['color'] == null ? undefined : json['color'],
        'license': json['license'] == null ? undefined : json['license'],
    };
}

export function CompanyCreateRequestToJSON(json: any): CompanyCreateRequest {
    return CompanyCreateRequestToJSONTyped(json, false);
}

export function CompanyCreateRequestToJSONTyped(value?: CompanyCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
        'heroImage': value['heroImage'],
        'color': value['color'],
        'license': value['license'],
    };
}

